
import { defineComponent } from "vue";
import Timer from "./Timer.vue";
export default defineComponent({
  name: "Form-Component",
  components: { Timer },
  emits: ["savingTask"],
  data() {
    return {
      descriptionTask: "",
    };
  },
  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },
  methods: {
    endTask(timeTotal: number): void {
      this.$emit("savingTask", {
        duration: timeTotal,
        description: this.descriptionTask,
      });
      const task: { description: string; duration: number } = {
        description: this.descriptionTask,
        duration: timeTotal,
      };
      const tasks: { description: string; duration: number }[] = JSON.parse(
        localStorage.getItem("tasks") ?? "[]"
      );
      tasks.push(task);
      localStorage.setItem("tasks", JSON.stringify(tasks));
      this.descriptionTask = "";
    },
  },
});
